"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconEquipmentSuppliesThematic = void 0;
var React = __importStar(require("react"));
var IconEquipmentSuppliesThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M19.2773,14.554 C18.8393,14.554 16.1683,14.223 11.8983,13.639 C11.9713,13.476 12.0463,13.311 12.1223,13.141 L20.1653,14.29 C19.8813,14.442 19.5693,14.554 19.2773,14.554 L19.2773,14.554 Z M8.4803,20 C7.6563,20 6.9853,19.327 6.9853,18.5 C6.9853,17.673 7.6563,17 8.4803,17 C9.3053,17 9.9763,17.673 9.9763,18.5 C9.9763,19.327 9.3053,20 8.4803,20 L8.4803,20 Z M6.9393,12.954 C6.9663,12.807 6.9853,12.656 6.9853,12.5 C6.9853,12.452 6.9733,12.408 6.9713,12.361 L9.5883,12.771 L9.3263,13.298 C8.2233,13.145 7.3793,13.02 6.9393,12.954 L6.9393,12.954 Z M4.4923,14 C3.6683,14 2.9973,13.327 2.9973,12.5 C2.9973,11.673 3.6683,11 4.4923,11 C5.3173,11 5.9883,11.673 5.9883,12.5 C5.9883,13.327 5.3173,14 4.4923,14 L4.4923,14 Z M14.8593,4.406 C14.8603,4.403 14.9103,4.296 15.0063,4.158 C13.5703,7.511 10.5173,14.282 9.6123,16.285 C9.4373,16.196 9.2543,16.122 9.0593,16.075 L14.8593,4.406 Z M12.5483,12.192 C14.0693,8.797 15.8903,4.696 16.4923,3.186 L16.7653,2.5 L16.0293,2.5 C14.6423,2.5 13.9793,3.929 13.9603,3.974 L10.0553,11.831 L6.6653,11.3 C6.2403,10.53 5.4313,10 4.4923,10 C3.1183,10 2.0003,11.121 2.0003,12.5 C2.0003,13.879 3.1183,15 4.4923,15 C5.3473,15 6.1023,14.566 6.5513,13.907 C6.8283,13.949 7.6643,14.075 8.8573,14.242 L7.9543,16.059 C6.8323,16.302 5.9883,17.303 5.9883,18.5 C5.9883,19.879 7.1063,21 8.4803,21 C9.8553,21 10.9733,19.879 10.9733,18.5 C10.9733,17.907 10.7573,17.367 10.4113,16.939 C10.6143,16.49 10.9943,15.649 11.4713,14.589 C16.1253,15.227 18.7663,15.554 19.2773,15.554 C20.5293,15.554 21.6693,14.448 21.7943,14.322 L22.5003,13.615 L12.5483,12.192 Z" }))); };
exports.IconEquipmentSuppliesThematic = IconEquipmentSuppliesThematic;
exports.IconEquipmentSuppliesThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconEquipmentSuppliesThematic;
